import {
  assign,
  cloneDeep,
  concat,
  each,
  filter,
  find,
  get,
  isEmpty,
  merge,
  omit,
  set,
  toLower,
  toUpper,
  upperFirst,
} from 'lodash';
import numeral from 'numeral';
import { momentable } from '../mixins';
import types from './mutationTypes';

const setZeroValue = (payload) => {
  let value = null;
  value = payload === -1 ? '00' : payload;

  return value;
};

const setTableItems = (payload) => {
  const dashChar = '-';
  const { totals } = payload;
  let items = [];

  if (payload.items && payload.items.length) {
    each(payload.items, (item) => {
      const ticket = {
        id: item.id,
        barcode: item.barcode ? item.barcode : dashChar,
        round: item.round ? item.round.displayId : item.displayId,
        jackpotWinAmount: item.jackpotWinAmount ? numeral(item.jackpotWinAmount).format('0.00') : dashChar,
        color: item.round ? item.round.color : item.color,
        result: item.round ? setZeroValue(item.round.result) : setZeroValue(item.result),
        rtp: item.rtp ? numeral(item.rtp).format('0.00') : dashChar,
        createdAt: momentable.methods.formatDateTime(item.createdAt, payload.timezoneOffset),
        paidOutAt: momentable.methods.formatDateTime(item.paidOutAt, payload.timezoneOffset),
        canceledAt: momentable.methods.formatDateTime(item.canceledAt, payload.timezoneOffset),
        resolvedAt: momentable.methods.formatDateTime(item.resolvedAt, payload.timezoneOffset),
        totalStake: numeral(item.totalStake).format('0.00'),
        totalPaymentTax: numeral(item.totalPaymentTax).format('0.00'),
        totalPayment: numeral(item.totalPayment).format('0.00'),
        totalPayout: numeral(item.totalPayout).format('0.00'),
        totalPayoutTax: numeral(item.totalPayoutTax).format('0.00'),
        totalPayoutAfterTax: numeral(item.totalPayoutAfterTax).format('0.00'),
        totalPossiblePayoutTax: numeral(item.totalPossiblePayoutTax).format('0.00'),
        totalPossiblePayout: numeral(item.totalPossiblePayout).format('0.00'),
        paymentBetshopName: item.paymentBetshopName ? item.paymentBetshopName : dashChar,
        paymentOperatorName: item.paymentOperatorName ? item.paymentOperatorName : dashChar,
        paymentRetailRegisterId: item.paymentRetailRegisterId
          ? item.paymentRetailRegisterId : dashChar,
        paymentRetailRegisterName: item.paymentRetailRegisterName
          ? item.paymentRetailRegisterName : dashChar,
        payoutBetshopName: item.payoutBetshopName ? item.payoutBetshopName : dashChar,
        payoutOperatorName: item.payoutOperatorName ? item.payoutOperatorName : dashChar,
        cancelBetshopName: item.cancelBetshopName ? item.cancelBetshopName : dashChar,
        cancelOperatorName: item.cancelOperatorName ? item.cancelOperatorName : dashChar,
        playerUsername: item.playerUsername ? item.playerUsername : dashChar,
        status: toUpper(item.status.title),
      };
      items = concat(items, ticket);
    });
    each(totals, (item, index) => {
      totals[index] = numeral(item).format('0.00');
    });

    set(payload.totals, 'total', true);
    items = concat(items, payload.totals);
  }

  return items;
};

const setJackpotTableItems = (payload) => {
  let items = [];

  if (payload.items && payload.items.length) {
    each(payload.items, (item) => {
      const jackpot = {
        id: item.id,
        barcode: item.barcode,
        createdAt: momentable.methods.formatDateTime(item.createdAt, payload.timezoneOffset),
        jackpotWinAmount: numeral(item.winAmount).format('0.00'),
      };
      items = concat(items, jackpot);
    });

    items = concat(items, { jackpotWinAmount: numeral(payload.totals.totalWinAmount).format('0.00') });
  }

  return items;
};

const setBetValues = (payload) => {
  const values = payload;
  each(values, (item) => {
    const value = item;
    value.number = setZeroValue(item.number);
  });

  return values;
};

const setTicketBets = (payload) => {
  let bets = [];
  const ticket = find(payload.tickets, item => item.id === payload.ticketId);

  if (ticket) {
    each(payload.ticketBets, (item) => {
      const bet = {
        round: ticket.round,
        type: item.title,
        value: setBetValues(item.selection),
        totalStake: item.stake.toFixed(2),
        totalPayout: item.status.name !== 'pending' && item.status.name !== 'closed' ? item.winnings.toFixed(2) : '-',
        status: toUpper(item.status.title),
      };
      bets = concat(bets, bet);
    });
  }

  return bets;
};

const setToolbarFilters = (payload) => {
  const items = {};

  each(payload.filters, (item, index) => {
    const key = `toolbar${upperFirst(index)}Label`;
    items[index] = {
      text: payload.translations[key],
      id: index !== 'players' ? 'id' : 'playerId', // THIS WILL BE CHANGE //
      route: 'tickets',
      selected: [],
      search: null,
      status: false,
      title: index !== 'players' ? 'title' : 'playerUsername', // THIS WILL BE CHANGE //
      filters: item.length,
    };
  });

  return items;
};

const setChannels = (payload) => {
  let channels = [];

  if (payload) {
    each(payload, (item) => {
      const channel = {
        text: item.displayName,
        id: item.betChannelId,
      };
      channels = concat(channels, channel);
    });
  }

  return channels;
};

export default {
  [types.SET_CONFIG](state, config) {
    assign(state.config, omit(config, ['round', 'translations']));
    state.round = config.round;
  },
  [types.SET_TRANSLATIONS](state, translations) {
    if (!isEmpty(translations)) {
      state.translations = merge({}, state.translations, translations);
    }
  },
  [types.SET_PLATFORM](state, platform) {
    state.platform = platform;
  },
  [types.SET_ROUNDS](state, payload) {
    const rounds = setTableItems(payload);
    state.rounds = rounds;
  },
  [types.SET_JACKPOTS](state, payload) {
    const jackpots = setJackpotTableItems(payload);
    state.jackpots = jackpots;
  },
  [types.SET_USER](state, payload) {
    state.user = payload.user;
  },
  [types.SET_TICKETS](state, payload) {
    const tickets = setTableItems(payload);
    state.tickets = tickets;
  },
  [types.SET_TICKET_BETS](state, payload) {
    const bets = setTicketBets(payload);
    state.ticketBets = bets;
  },
  [types.SET_PAGINATION](state, payload) {
    const config = payload;
    const sortBy = toLower(payload.sortBy);
    if (payload) {
      if (sortBy.includes('status')) {
        config.sortBy = 'status';
      }
      if (sortBy.includes('displayid')) {
        config.sortBy = 'round';
      }
      if (sortBy.includes('winamount')) {
        config.sortBy = 'jackpotWinAmount';
      }
      if (sortBy.includes('attr_')) {
        const sort = payload.sortBy.split('_')[1];
        config.sortBy = sort;
      }
    }
    state.paginationConfig = config;
  },
  [types.SET_TICKET_FILTERS](state, filters) {
    if (!state.channels.length) {
      const productChannels = get(filters, 'betChannels');
      const [firstChannel] = productChannels;
      state.channel = firstChannel.betChannelId;
      state.channels = setChannels(productChannels);
    }
    const productChannel = state.channel;
    const selectedFilters = {};
    let ticketFilters = filters;

    ticketFilters.paymentOperators = filter(filters.paymentOperators, item => item.id !== null);
    ticketFilters.paymentBetshops = filter(filters.paymentBetshops, item => item.id !== null);
    ticketFilters.paymentCashRegisters = filter(filters.paymentCashRegisters,
      item => item.name !== null);

    if (productChannel === 1 || productChannel === 3) {
      ticketFilters = omit(ticketFilters, 'players');
      if (productChannel === 3) {
        ticketFilters = omit(ticketFilters, 'paymentOperators');
      }
    } else {
      ticketFilters = omit(ticketFilters, 'paymentBetshops');
      ticketFilters = omit(ticketFilters, 'paymentCashRegisters');
      ticketFilters = omit(ticketFilters, 'paymentOperators');
    }

    each(ticketFilters, (item, index) => {
      selectedFilters[index] = [];
    });
    state.selectedFilters = selectedFilters;
    state.ticketFilters = omit(ticketFilters, 'betChannels');
    const toolbarFilters = setToolbarFilters({
      filters: state.ticketFilters,
      translations: state.translations,
    });
    state.toolbarFilters = toolbarFilters;
  },
  [types.SET_FILTERS](state, payload) {
    state.selectedFilters[payload.filter] = payload.selected;
  },
  [types.RESET_FILTERS](state) {
    const toolbars = state.toolbarFilters;
    each(state.selectedFilters, (item, index) => {
      state.selectedFilters[index] = [];
    });
    state.toolbarFilters = cloneDeep(toolbars);
  },
  [types.RESET_TICKET_FILTERS](state) {
    state.toolbarFilters = {};
    state.selectedFilters = {};
  },
  [types.SET_USER_TOKEN](state, payload) {
    state.token = payload;
  },
  [types.SET_CHANNEL](state, payload) {
    state.channel = payload;
  },
  [types.SET_EXPORT_TYPE](state, payload) {
    state.exportType = payload;
  },
  [types.SET_INFO_MESSAGE](state, payload) {
    state.infoMessage = payload;
  },
  [types.UPDATE_CONFIG](state, plugin) {
    state.config.app = `${plugin.replace('Plugin', '')}Admin`;
    state.config.gateway.slaveId = plugin;
  },
};
